
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.965 7.912c-12.408 0-22.496 10.045-22.496 22.4 0 12.355 10.088 22.4 22.496 22.4s22.497-10.045 22.497-22.4c0-12.355-10.099-22.4-22.497-22.4zm0 42.81c-11.298 0-20.497-9.16-20.497-20.41S18.667 9.903 29.965 9.903c11.299 0 20.497 9.16 20.497 20.41s-9.198 20.409-20.497 20.409z"}}),_c('path',{attrs:{"d":"M39.224 29.317h-8.269v-8.234a1 1 0 00-2 0v8.234h-8.268a1 1 0 00-1 .995 1 1 0 001 .996h8.269v8.233a1 1 0 002 0v-8.233h8.268a1 1 0 001-.996.994.994 0 00-1-.995z"}})])
          )
        }
      }
    